import { useDataBoxStatus } from 'app/common/data-box-store'

import { sendersInfo } from '../dataBox'


export function useSendersInfoLoading() {
  const ready = useDataBoxStatus(sendersInfo, () => sendersInfo.ready)
  return !ready
}
